import { EmptyState } from "@/components/feedback/EmptyState";
import type { TableStateProps } from "./DataTable.types";

export function TableEmptyState({ title = "No records found", description, action, colSpan = 1, className }: TableStateProps) {
  return (
    <tr>
      <td colSpan={colSpan}>
        <EmptyState variant="table" title={title} description={description} primaryAction={action} className={className} />
      </td>
    </tr>
  );
}
